// import {
//   messageConfig
// } from '@/public/constant/template'
import { Decimal } from 'decimal.js'
import XEUtils from 'xe-utils'
import { MessageBox } from 'element-ui'
// import global from '@/uitls/methods/global.js'
export default {
  // 拉选合计
  tableSelectTotal(a) {
    let total = 0
    for (let area of a) {
      for (let column of area.cols) {
        if (Array.isArray(column.formatter)) {
          if (column.formatter.length > 2 && column.formatter[0] === 'formatAmount' && column.formatter[2] === false) {
            return '***'
          } else if (
            column.formatter.length > 1 &&
            column.formatter[0] === 'formatPrice' &&
            column.formatter[1] === false
          ) {
            return '***'
          }
        }
      }
    }
    a.forEach(area => {
      for (let row of area.rows) {
        for (let column of area.cols) {
          if (Number(row[column.property])) {
            total = new Decimal(total).add(new Decimal(row[column.property])).toNumber()
          }
        }
      }
    })
    return total
  },
  // 合并所选区域
  megerArea(areas) {
    let rows = []
    let cols = []
    areas.forEach(area => {
      area.rows.forEach(row => {
        rows.push(row)
      })
      area.cols.forEach(col => {
        cols.push(col)
      })
    })
    rows = global.distinct(rows)
    cols = global.distinct(cols)
    return {
      rows,
      cols
    }
  },

  // table 点击删除列
  removeRowForTable(row, table, data) {
    MessageBox.confirm('确定要删除本行吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        table.remove(row)
        if (data) {
          data.IfExistModify = true
        }
      })
      .catch(() => {})
  },
  // table 移除空行
  removeEmptyForTable(table, defaultArray = []) {
    let tableData = table.getTableData().fullData
    for (let row of tableData) {
      let ifRemove = true
      for (let key in row) {
        if (key !== '_XID' && !defaultArray.includes(key)) {
          if (row[key] !== null) {
            ifRemove = false
          }
        }
      }
      if (ifRemove) {
        table.remove(row)
      }
    }
  },
  // table 返回重复行
  repeatForTable(errIndex, table, defaultArray = []) {
    let tableData = []
    if (XEUtils.isArray(table)) {
      tableData = table
    } else {
      tableData = table.getTableData().fullData
    }
    // 新数组
    let newData = []
    let rowIndex = 0
    let re = /^[-]?\d+(\.\d+)?$/
    for (let row of tableData) {
      // 重复rowIndex
      let repeatRowIndex = -1
      // 遍历新数组
      for (let row1 of newData) {
        // 是否重复
        let ifrepeat = true
        // 遍历是否重复
        for (let key of defaultArray) {
          let value = row[key]
          let value1 = row1[key]
          if (value === null) {
            value = ''
          }
          if (value1 === null) {
            value1 = ''
          }
          if (re.test(value) && re.test(value1)) {
            value = Number(value)
            value1 = Number(value1)
          }
          if (value !== value1) {
            ifrepeat = false
            break
          }
        }
        if (ifrepeat) {
          repeatRowIndex = row1['rowIndex']
          row['ifRepeat'] = true
          row['repeatText'] = `与第${repeatRowIndex + 1}行数据重复`
          break
        }
      }
      if (repeatRowIndex >= 0) {
        errIndex.push({
          _XID: row._XID,
          columnIndex: 0,
          repeatRowIndex: repeatRowIndex
        })
      } else {
        let newrow = {
          ...row
        }
        newrow['rowIndex'] = rowIndex
        newData.push(newrow)
      }
      rowIndex = rowIndex + 1
    }
  }
}
